import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const ShoppingIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "ShoppingIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}

      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.39952 22.0196C6.2438 22.0196 6.0945 21.9578 5.98445 21.8477L3.63632 19.4996C3.52619 19.3894 3.46436 19.2401 3.46436 19.0844V8.47869C3.46436 8.1545 3.72719 7.89166 4.05139 7.89166H6.98656V4.91735C6.98656 4.76276 7.04988 4.61107 7.15817 4.50259L9.50666 2.1541C9.61671 2.04401 9.76601 1.98218 9.92173 1.98218H14.618C14.7737 1.98218 14.923 2.04401 15.0331 2.1541L17.3816 4.50263C17.4873 4.60849 17.5532 4.75975 17.5532 4.91735V7.89166H20.4883C20.8125 7.89166 21.0754 8.15449 21.0754 8.47869V19.0844C21.0754 19.2401 21.0135 19.3894 20.9034 19.4996L18.5553 21.8477C18.4452 21.9578 18.2959 22.0196 18.1402 22.0196H6.39952ZM15.205 5.50439V7.89166H16.3791V5.50439H15.205ZM10.5088 5.50439V7.89166H14.031V5.50439H10.5088ZM14.3749 3.15625H10.1649L8.99082 4.33032H15.5489L14.3749 3.15625ZM9.3347 5.50439H8.16063V7.89166H9.3347V5.50439ZM19.9013 9.06573H4.63842V18.8413L6.64267 20.8455H17.8971L19.9013 18.8413V9.06573ZM6.77002 11C6.77002 10.7239 6.99388 10.5 7.27002 10.5H8.54926C9.18585 10.5 9.75202 10.9016 9.96348 11.5H16.1072C16.7715 11.5 17.2512 12.1359 17.0687 12.7747L16.458 14.9121C16.274 15.556 15.6854 16 15.0157 16H12.27H11.4908H11.27C10.9939 16 10.77 16.2239 10.77 16.5C10.77 16.7761 10.9939 17 11.27 17H15.27L15.2771 17C15.8261 17.0039 16.27 17.4501 16.27 18C16.27 18.5523 15.8223 19 15.27 19C14.7177 19 14.27 18.5523 14.27 18V18H12.27V18C12.27 18.5523 11.8223 19 11.27 19C10.7177 19 10.27 18.5523 10.27 18C10.27 17.8831 10.29 17.7708 10.3269 17.6665C9.98722 17.3915 9.77002 16.9711 9.77002 16.5C9.77002 16.0536 9.96501 15.6528 10.2745 15.378C10.187 15.2569 10.1168 15.1214 10.0678 14.9743L9.0236 11.8419C8.95554 11.6377 8.76448 11.5 8.54926 11.5H7.27002C6.99388 11.5 6.77002 11.2761 6.77002 11ZM15.0157 15H12.27H11.4908C11.2756 15 11.0845 14.8623 11.0164 14.6581L10.2971 12.5H16.1072L15.4965 14.6374C15.4352 14.852 15.239 15 15.0157 15Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default ShoppingIcon;
